var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3402_8747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3657 0.0703125H6.86572C3.08572 0.0703125 0.115723 3.04031 0.115723 6.82031V20.3203C0.115723 24.1003 3.08572 27.0703 6.86572 27.0703H20.3657C24.1457 27.0703 27.1157 24.1003 27.1157 20.3203V6.82031C27.1157 3.04031 24.1457 0.0703125 20.3657 0.0703125ZM24.4157 20.3203C24.4157 22.6153 22.6607 24.3703 20.3657 24.3703H6.86572C4.57072 24.3703 2.81572 22.6153 2.81572 20.3203V6.82031C2.81572 4.52531 4.57072 2.77031 6.86572 2.77031H20.3657C22.6607 2.77031 24.4157 4.52531 24.4157 6.82031V20.3203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6157 6.82031C9.83572 6.82031 6.86572 9.79031 6.86572 13.5703C6.86572 17.3503 9.83572 20.3203 13.6157 20.3203C17.3957 20.3203 20.3657 17.3503 20.3657 13.5703C20.3657 9.79031 17.3957 6.82031 13.6157 6.82031ZM13.6157 17.6203C11.3207 17.6203 9.56572 15.8653 9.56572 13.5703C9.56572 11.2753 11.3207 9.52031 13.6157 9.52031C15.9107 9.52031 17.6657 11.2753 17.6657 13.5703C17.6657 15.8653 15.9107 17.6203 13.6157 17.6203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3656 8.17021C21.1112 8.17021 21.7156 7.5658 21.7156 6.82021C21.7156 6.07463 21.1112 5.47021 20.3656 5.47021C19.62 5.47021 19.0156 6.07463 19.0156 6.82021C19.0156 7.5658 19.62 8.17021 20.3656 8.17021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3402_8747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.115723 0.0703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.0e1791e36486e486eb908bb9ab73a2e6.svg";
export { ForwardRef as ReactComponent };